import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import langReducer from './langSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    lang: langReducer,
  },
});

export default store;
